import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { EmptyState } from './EmptyState';
import { Panel } from './Panel';
import { toneColor, type Tone } from './tone';

export type ActivityItem = { id: string; tone: Tone; date: string; text: ReactNode };

/** A "Recent Activity" box: a coloured dot, the date, and what happened */
export function ActivityList({ items }: { items: ActivityItem[] }) {
  return (
    <Panel title="Recent Activity">
      {items.length ? (
        <Stack spacing={1.25}>
          {items.map((a) => (
            <Stack key={a.id} direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
              <Box
                sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: toneColor(a.tone), mt: 0.8, flexShrink: 0 }}
              />
              <Typography variant="caption" color="text.secondary" sx={{ width: 84, flexShrink: 0, pt: 0.25 }}>
                {a.date}
              </Typography>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {a.text}
              </Typography>
            </Stack>
          ))}
        </Stack>
      ) : (
        <EmptyState>No activity yet.</EmptyState>
      )}
    </Panel>
  );
}
